import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const initialState = {
  Head: {
    A_Transid:"",
    A_Date:moment(),
    A_Loc:"",
    Loc_Name:"",
    A_Narration:"",
    A_Status:"ENTER",
    CreatedBy:"",
    CreatedDate:"",
    ApproveStatus:"ENTER",
    ApprovedBy:"",
    ApproveDt:"",
    A_StatusCM:"ENTER",
    A_CM_By:"",
    A_CM_Dt:"",
    A_StatusPM:"ENTER",
    A_PM_By:"",
    A_PM_Dt:"",
    A_LocCSV:"",
    LoccsvName:""
  },
};

const SliceRSPChangeRequest = createSlice({
  name: "SliceRSPChangeRequest",
  initialState: { value: initialState },

  reducers: {
    Head_Set: (state, action) => {
      state.value.Head = action.payload;
    },

    StockSetupChangeRequest_Init: (state) => {
      state.value = initialState;
    },
  },
});

export const { Head_Set } = SliceRSPChangeRequest.actions;
export default SliceRSPChangeRequest.reducer;
